const $filterMenu = $('.dnk-filter-menu')
const $categories = $('.dnk-page-header__categories')

$filterMenu.on('click', function() {
  $categories.slideToggle(600, function() {})
});